import { useMutation } from 'convex/react';
import { api } from 'convex/_generated/api';

export function useUpdateGarden() {
  return useMutation(api.gardens.mutations.updateGarden).withOptimisticUpdate(
    (localStore, { gardenId, plants: newPlants }) => {
      const current = localStore.getQuery(api.gardens.queries.getGardenById, { gardenId });
      if (current === undefined) return;

      localStore.setQuery(
        api.gardens.queries.getGardenById,
        { gardenId },
        { ...current, plants: newPlants }
      );
    }
  );
}
